import CourseDetailAPI from '@/apis/business/MISAStore/course-detail-api.js'
import PracticeCourseAPI from '@/apis/business/student/practice-course-api.js'
import Enumeration from '@/common/enumeration'
import { HttpStatusCode } from '@/common/constant'
export default {
  namespaced: true,

  state: {
    courseDetail: [],
    courseDeatilTrees: [],
    thematic: Enumeration.CourseDetailType.Thematic,
    examGroup: Enumeration.CourseDetailType.ExamGroup,
    video: Enumeration.CourseDetailType.Video,
    topic: Enumeration.CourseDetailType.Topic,
    lesson: Enumeration.CourseDetailType.Lesson,
    videoIntro: {},
    courses: [],
    courseID: null,
    studentPackageDetail: null,
    lessionID: null,
    checkPaused: false,
    quizLessons: {},
    videoProgressLesson: {
      VideoProgress: 0,
      TotalVideo: 1
    },
    viewProgressOld: 0,
    videoProLesson: 0,
    lesonVideoProgressOld: 0,
    lessonDetail: {},
    viewPopupCourse: false,
    courseDetailLessonFree: [],
    isBuyCourse: null
  },

  getters: {},

  mutations: {

    setPopupUseCourse (state, data) {
      state.viewPopupCourse = data
    },

    setVideoProgressOld (state, data) {
      state.viewProgressOld = data
    },

    setPractiveCourseByCourseID (state, data) {
      state.isBuyCourse = data
    },

    /**
     * Lưu value của bài giảng
     * @param {*} state
     * @param {*} lessonDetail
     */
    setLessonDetail (state, lessonDetail) {
      state.lessonDetail = lessonDetail
    },

    /**
     * Lưu thông tin thay đổi
     * @param {*} state
     * @param {*} videoProgress
     */
    setVideoProgressLesson (state, videoProgress) {
      state.videoProgressLesson = videoProgress
    },

    /**
     * @author NVDuc
     * @description Check sự kiện nút pause
     * @param {*} state
     * @param {*} check
     */
    setCheckPaused (state, check) {
      state.checkPaused = check
    },
    /**
     * Lấy Id Bài học đầu tiên của khóa học
     */
    setLessionId (state, data) {
      const firstLesson = data?.find(
        (x) => x.Type === Enumeration.CourseDetailType.Lesson
      )
      state.lessonID = firstLesson?.LessonID
    },
    setCouseLessons (state, data) {
      const courseParamLesson = data?.filter((element) => {
        return element.Type === state.lesson && element.IsFree === true
      })
      state.courseDetailLesson = courseParamLesson
    },
    /**
     * Xét giá trị cho courseDetail
     * @param {*} state
     * @param {*} courseDetail
     */
    setCourseDetail (state, courseDetail) {
      const courseParamLesson = courseDetail?.filter((element) => {
        return element.Type === state.lesson && element.IsFree === true
      })
      state.courseDetailLessonFree = courseParamLesson
      // state.courseDetail = courseDeta
      if (courseDetail?.length > 0) {
        courseDetail?.forEach((element) => {
          element.children = courseDetail.filter((childVideo) => {
            return (
              element.Id === childVideo.ParentID &&
              childVideo.Type !== state.examGroup &&
              childVideo.Type !== state.video
            )
          })
        })
        // tìm kiếm những học liệu có topic=5
        // state.courseDetail = courseDetail
        let courseDetailFilter = courseDetail?.filter((element) => {
          // if (element.Type === state.topic) {
          return element.Type === state.topic
          // }
          // return element.Type === state.thematic
        })
        //  Nếu ko có
        if (!courseDetailFilter.length) {
          courseDetailFilter = courseDetail?.filter((element) => {
            // if (element.Type === state.topic) {
            return element.Type === state.thematic
            // }
            // return element.Type === state.thematic
          })

          courseDetailFilter = courseDetailFilter.map((element) => {
            element.Type = state.topic
            return element
          })
        }
        state.courseDetail = courseDetailFilter
      }
    },

    /**
     * Xét video giới thiệu
     * @param {} state
     * @param {*} videoIntro
     */
    setVideo (state, videoIntro) {
      state.videoIntro = videoIntro
    },

    /**
     * Xét giá trị cho course
     * @param {*} state
     * @param {*} course
     */
    setCourse (state, course) {
      if (!state.courses.IsBuy) {
        state.courses.IsBuy = false
      }
      state.courses = course
    },

    setPracticeCourseByID (state, courseID) {
      state.courseID = courseID
      state.courses.IsBuy = true
    },

    /**
     * @description set dữ liệu cho state studentPackageDetail
     * @author PVThang
     * @param {*} state
     * @param {*} studentPackageDetail
     */
    setStudentPackageDetail (state, studentPackageDetail) {
      state.studentPackageDetail = studentPackageDetail
    },

    /**
     * @description set dữ liệu câu hỏi nhanh của bài giảng
     * @author VDDung1
     * @param {*} state
     * @param {*} quizDetail
     */
    setQuizDetail (state, quizDetail) {
      state.quizLessons = quizDetail
    }
  },

  actions: {
    /**
     * Lấy list course-detail theo courseID
     * @param {*} context
     * @param {*} param
     * @returns
     * CreateBy: NVDuc 20.09
     */
    getCourseDetail (context, param) {
      return new Promise((resolve, reject) => {
        CourseDetailAPI.getAsync(`id/${param}`)
          .then((res) => {
            context.commit('setCourseDetail', res.Data.ListCourseDetail)
            context.commit('setVideo', res.Data.Video)
            context.commit('setCourse', res.Data.HocMaiCourse)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Thêm 1 học liệu vào bảng PracticeCourse
     * @param {*} context
     * @param {*} params
     * @returns
     */
    postPracticeCourse (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.postAsync('courseParam', params)
          .then((res) => {
            context.commit('setPracticeCourseByID', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy chi tiết PartnerID
     * @param {*} context
     * @param {*} params
     */
    getPracticeCourseByPartnerID (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(`partnerID/${params}`)
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getPractiveCourseByCourseID (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(`courseID/${params}`)
          .then((res) => {
            context.commit('setPractiveCourseByCourseID', res.Data)
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy chi tiết học liệu PracticeCourse
     * @param {*} context
     * @param {*} params
     * @returns
     */
    getPracticeCourseDetail (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(
          `id/${params.id}?source=${params.source}&sourceType=${params.sourceType}`
        )
          .then((res) => {
            context.commit('setCourseDetail', res.Data?.ListCourseDetail)
            context.commit('setVideo', res.Data?.Video)
            context.commit('setCourse', res.Data?.PracticeCourse)
            context.commit('setStudentPackageDetail', res.Data?.PackageDetail)
            context.commit('setLessionId', res.Data?.ListCourseDetail)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    getCourseDetailView (context, params) {
      return new Promise((resolve, reject) => {
        PracticeCourseAPI.getAsync(`view/id/${params.id}/${params.courseID}/${params.idTopic}`)
          .then((res) => {
            context.commit('setCourseDetail', res.Data.ListCourseDetail)
            // context.commit('setCouseLessons', res.Data?.ListCourseDetail)
            // context.commit('setCourse', res.Data.HocMaiCourse)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * @author PVThang
     * @description
     */
    async getCourseDetailsByLessonID (context, params) {
      if (!params) {
        return
      }

      return await CourseDetailAPI.getAsync(
        `${params.courseID}/${params.lessonID}`,
        {
          params: {
            isGetDetailOfFirst: params.isGetDetailOfFirst,
            courseObjectId: params.courseObjectId
          }
        }
      )
    },

    /**
     * @author PVThang
     * @description Lấy thông tin bài học theo ID bài
     */
    async getVideosByLessonID (context, params) {
      if (!params?.lessonID) {
        return
      }
      return await CourseDetailAPI.getAsync(`lesson/${params?.lessonID}`, {
        params: {
          courseObjectId: params?.courseObjectId
        }
      })
    },

    /**
     * @author PVThang
     * @description lấy chi tiết của video
     */
    async getVideo (context, params) {
      if (!params?.lessonID || !params.videoID || !params.courseObjectId) {
        return
      }
      return await CourseDetailAPI.getAsync(
        `lesson/${params.lessonID}/${params.videoID}`
      )
    },

    /**
     * @author VDDung1
     * @description get video stream
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getVideoStream (context, params) {
      if (!params?.userAgent || !params.videoID) {
        return
      }
      return await CourseDetailAPI.getAsync(`video/${params.videoID}`, {
        params: {
          userAgent: params.userAgent
        }
      })
    },

    /**
     * @author VDDung1
     * @description get quiz lesson
     * @param {*} context
     * @param {*} params
     * @returns
     */
    async getQuizInLesson (context, params) {
      return new Promise((resolve, reject) => {
        CourseDetailAPI.getAsync(`quiz/${params}`)
          .then((res) => {
            if (res && res.Data) {
              const data = JSON.parse(res.Data)
              const dataObject = JSON.parse(data)
              if (dataObject.code === HttpStatusCode.Unauthorized) {
                resolve(false)
              } else {
                resolve(data)
              }
            } else {
              resolve(false)
            }
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
